import { Suspense } from 'react';
import { Routes } from 'react-router-dom';
import { ThemeProvider } from './providers/ThemeContext';
import { AuthProvider } from './providers/AuthContext';
import { PaywallProvider } from './providers/PaywallContext';
import { ErrorBoundary, LambLoader } from '../shared/components';
import { appRoutes } from './routes';
import { PageContextTracker } from './PageContextTracker';
import { captureUtmParams } from '../utils/utmCapture';

// Capture UTM params from URL before any navigation
captureUtmParams();

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <PaywallProvider>
            <div className="App">
              <Suspense fallback={<LambLoader />}>
                <PageContextTracker />
                <Routes>
                  {appRoutes}
                </Routes>
              </Suspense>
            </div>
          </PaywallProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
